import { categories } from '@/mocks/chigua';
import { SectionHead } from './HotDeep';
import { categoryIcon } from './icons';

export function Categories() {
  return (
    <section id="category" className="border-y border-background-200 bg-background-100">
      <div className="mx-auto max-w-7xl px-4 py-16 md:px-6 md:py-20">
        <SectionHead
          eyebrow="Sections"
          title="走进不同瓜田"
          desc="每个栏目都有自己的一套看门道，选你感兴趣的方向直接开吃。"
        />
        <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {categories.map((c) => (
            <a
              key={c.name}
              href="#dive"
              className="group flex cursor-pointer items-start gap-4 rounded-xl border border-background-200 bg-background-50 p-5 transition-colors hover:border-primary-300"
            >
              <span className="grid h-12 w-12 shrink-0 place-items-center rounded-lg bg-secondary-100 text-xl text-secondary-700 transition-colors group-hover:bg-primary-500 group-hover:text-background-50">
                <i className={categoryIcon(c.icon)}></i>
              </span>
              <div className="min-w-0">
                <div className="flex items-center gap-2">
                  <h3 className="font-heading text-lg font-bold text-foreground-950">{c.name}</h3>
                  {c.featured && (
                    <span className="inline-flex rounded-full bg-accent-500 px-2 py-0.5 text-xs font-bold text-accent-50">
                      常更
                    </span>
                  )}
                </div>
                <p className="mt-1 text-sm text-foreground-600">{c.desc}</p>
                <p className="mt-2 text-xs text-foreground-400">{c.posts} 篇档案</p>
              </div>
              <i className="ml-auto mt-2 text-foreground-300 transition-all group-hover:translate-x-1 group-hover:text-primary-500 ri-arrow-right-line"></i>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}